import { useContext } from "react";
import { Col, Container, Input, Label, Row } from "reactstrap";
import { slugUrlConverter } from "../../../../utils/helper";
import TableOrListingContext from "../../../context/TableOrListingContext/TableOrListingContext";

const TableOrListParentPopup = (props) => {
  const { simpleValidator } = props;
  const { isEdit, formDataParent, setFormDataParent } = useContext(
    TableOrListingContext
  );

  const changeFormValue = (e) => {
    const { value, name, checked } = e.target;
    setFormDataParent((prev) => {
      let updatedData =
        name === "isTitleShow"
          ? {
              ...prev,
              [name]: checked,
            }
          : {
              ...prev,
              [name]: value,
            };
      if (name === "title" || name === "slugUrl") {
        updatedData.slugUrl = slugUrlConverter({ value: value });
      }
      return updatedData;
    });
  };

  return (
    <Container className="mb-5">
      <Row>
        <Col sm="12" xl="12">
          <div className="mt-4 d-flex flex-column justify-content-center ">
            <h6>{isEdit ? "Edit" : "Add New"}</h6>
            <Row className="mt-4">
              <Col md="12 mb-3">
                <Label htmlFor="validationCustom03">{"Title *"}</Label>
                <Input
                  className="form-control"
                  name="title"
                  type="text"
                  placeholder="Title"
                  value={formDataParent?.title}
                  onChange={(e) => changeFormValue(e)}
                  style={{ borderRadius: "0", color: "black" }}
                />
                <p style={{ color: "red" }}>
                  {simpleValidator.current.message(
                    "Title",
                    formDataParent.title,
                    "required"
                  )}
                </p>
              </Col>
              <Col md="12 mb-3">
                <Label htmlFor="validationCustom03">{"Slug Url *"}</Label>
                <Input
                  className="form-control"
                  name="slugUrl"
                  type="text"
                  placeholder="Slug Url *"
                  value={formDataParent.slugUrl}
                  onChange={(e) => changeFormValue(e)}
                  // onBlur={() => handleFocusChange()}
                  style={{ borderRadius: "0", color: "black" }}
                />
                <p style={{ color: "red" }}>
                  {simpleValidator.current.message(
                    "slugUrl",
                    formDataParent.slugUrl,
                    "required"
                  )}
                </p>
              </Col>
              <Col md="12 mb-3">
                <Label htmlFor="validationCustom03">{"Sub Title"}</Label>
                <Input
                  className="form-control"
                  name="subTitle"
                  type="text"
                  placeholder="Sub Title"
                  value={formDataParent?.subTitle}
                  onChange={(e) => changeFormValue(e)}
                  style={{ borderRadius: "0", color: "black" }}
                />
              </Col>{" "}
            </Row>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default TableOrListParentPopup;
